import { LoginLegalAgreeText } from "../../login/LoginLegalAgreeText";

export const LOGIN_LEGAL_AGREE_PROMPT = {
  title: "服务协议确认",
  uncheckedTip: "请先阅读并同意用户协议和隐私政策",
  children: <LoginLegalAgreeText linkClassName="legal-agree-prompt-link" />,
};
